module.exports = __webpack_public_path__ + "static/White_Paper_Survey.1600309d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/White_Paper_Survey.pdf
// module id = 74
// module chunks = 31532440822795 35783957827783 230781006321697